import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Core from "../components/core-view";
import {
  isUserInvitationPage,
  isInvitationAcceptancePage,
  getIRPSourceParams,
} from "lib/utility-functions";
import {
  uiAlertAuthenticationWarningVisible,
  uiAlertAuthenticationExpiredVisible,
  uiToastrMessage,
  uiConfirmDialog,
  uiMessageBannerVisible,
  uiShowMessageBanner,
} from "modules/ui-module";
import { meIsConflicted } from "modules/me-module";
import { meRequestGet } from "modules/me-service-module";
import auth from "lib/profile-auth";
import {currentUserLogged} from 'modules/tracking/tracking-constants';
import useAmplitudePageView from 'modules/tracking/amplitude-module';
import useAmplitude from 'lib/amplitude-tracking';

export const CoreContainer = () => {
  const {
    alertAuthWarningIsVisible,
    alertAuthExpiredIsVisible,
    messageBannerVisible,
    toastrMessage,
    confirmDialog,
    isUserConflicted,
    logout,
  } = useSelector(getValuesFromStore);
  const dispatch = useDispatch();
  const track = useAmplitudePageView();
  const { identify } = useAmplitude();
  const [userHasPasskey, setUserHasPasskey] = useState();
  const [passkeyCredentialIsLoading, setPasskeyCredentialIsLoading] = useState(true);
  useEffect(() => {
    if (isUserConflicted) {
      dispatch(
        uiShowMessageBanner("userIsConflicted", {
          onclick: handleSignOut,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserConflicted]);

  useEffect(()=>{
    if (!sessionStorage.getItem("current_user_logged")) {
      sessionStorage.setItem("current_user_logged", true);

      const irpSource = getIRPSourceParams();
      const trackingPayload = irpSource || {};

      if (irpSource) {
        identify({
          last_login_source: irpSource.login_source,
          last_login_flow: irpSource.login_flow
        });
      }

      track(currentUserLogged, trackingPayload);
    }
    const queryString = encodeURIComponent("{user {passKeyBannerClosedAt}}");
    dispatch(meRequestGet(queryString)).then(
      (res) => {
        const userAlreadyClosedBanner = !!(res?.payload?.user?.passKeyBannerClosedAt || false);
        if(userAlreadyClosedBanner) {
          setUserHasPasskey(true);
        }
        else {
          setUserHasPasskey(false);
        }
        setPasskeyCredentialIsLoading(false);
      },
      () => {
        setPasskeyCredentialIsLoading(false);
      }
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch]);

  const handleSignOut = () => {
    logout();
  };

  return (
    <Core
      alertAuthWarningIsVisible={alertAuthWarningIsVisible}
      alertAuthExpiredIsVisible={alertAuthExpiredIsVisible}
      messageBannerVisible={messageBannerVisible}
      toastrMessage={toastrMessage}
      confirmDialog={confirmDialog}
      userHasNoPasskey={!userHasPasskey && !passkeyCredentialIsLoading}
      useStandardNav={!(isUserInvitationPage() || isInvitationAcceptancePage())}
    />
  );
};
export const getValuesFromStore = (state) => ({
  alertAuthWarningIsVisible: uiAlertAuthenticationWarningVisible(state),
  alertAuthExpiredIsVisible: uiAlertAuthenticationExpiredVisible(state),
  messageBannerVisible: uiMessageBannerVisible(state),
  toastrMessage: uiToastrMessage(state),
  confirmDialog: uiConfirmDialog(state),
  isUserConflicted: meIsConflicted(state),
  logout: auth.logout.bind(auth),
});

export default CoreContainer;
